import { getOikosApiUrl } from '../../config/backendEnv'

export const linkProducaoPaginas = "https://oikos.ecoss.is/oikos-client/";
export const linkProducaoVM = "https://oikos.ecoss.is/oikos/";
export const linkOikosLabPaginas = "https://oikoslab.ecoss.is/";
export const linkOikosLabVM = "https://oikoslab.ecoss.is/oikos/";

/** Base de arquivos = host da API (lab ou prod conforme seletor/admin). */
export const getOikosFileUrl = (path) => {
  if (!path) return ''
  if (/^https?:\/\//i.test(path)) return path
  const api = getOikosApiUrl()
  const base = api.replace(/\/_oikos_api\.php.*$/i, '/').replace(/\/?$/, '/')
  return `${base}${String(path).replace(/^\//, '')}`
}
